import { type UserContent } from "@/types/content";
import { create } from "zustand";
import useMapboxStore from "./useMapboxStore";
import useProjectStore from "./useProjectStore";

interface AppState {
  user: UserContent | null;
  isAppLoading: boolean;
  setUser: (user: UserContent | null) => void;
  setIsAppLoading: (isAppLoading: boolean) => void;
  resetAppStore: () => void;
}

const initialState = {
  user: null,
  isAppLoading: false,
};

const useAppStore = create<AppState>()((set) => ({
  ...initialState,
  setUser: (user: UserContent | null) => {
    set({ user });
  },
  setIsAppLoading: (isAppLoading: boolean) => {
    set({ isAppLoading });
  },
  resetAppStore: () => {
    useMapboxStore.getState().resetMapboxState();
    useProjectStore.getState().resetProjectStore();
    set(initialState);
  },
}));

export default useAppStore;
